export const Constants = {
  TAG_NAME: 'pop-contact-us-component',
  COMPONENT_TITLE: 'Contact Us',
  CONTACT_NUMBER: '877.561.7670',
  CONTACT_EMAIL: 'advisorservices@troweprice.com',
  MAILTO_LINK: 'mailto:',
  TEL_LINK: 'tel:',
  SCHEDULER_BUTTON_LABEL: 'Schedule Appointment',
  SCHEDULER_BUTTON_LINK:
    'https://www.troweprice.com/financial-intermediary/us/en/scheduler/appointment.html',
  SUBSCRIBE_BUTTON_LABEL: 'Subscribe',
  ICON_SLOT: 'prefix',
  PHONE_ICON_ARIA_LABEL: 'Call us',
  EMAIL_ICON_ARIA_LABEL: 'Email us',
  EMAIL_BODY_TEXT:
    'Please be sure to provide your full name, telephone number, and enough information to allow us to adequately respond.',
  NO_VEHICLE_SUBJECT_LINE: 'Inquiry',
} as const;

export const VehicleSubjectLines: { [key: string]: string } = {
  SMA: 'Separately Managed Account Inquiry',
  ETF: 'Exchange-Traded Fund Inquiry',
  MF: 'Mutual Fund Inquiry',
  CIT: 'Collective Investment Trusts Inquiry',
};
